import { render } from "./MTests1View.vue?vue&type=template&id=5cebe572"
import script from "./MTests1View.vue?vue&type=script&lang=js"
export * from "./MTests1View.vue?vue&type=script&lang=js"

import "./MTests1View.vue?vue&type=style&index=0&id=5cebe572&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__